<app-sidebar></app-sidebar>




<!-- <div style="backg2round-color:rgb(244, 244, 244);height:100%"> -->


<div class="container" style="margin-left:340px;padding: 20px;">
  <div class="gap10"></div>


  <!-- <mat-card>
  <mat-card-content> -->
  <table class="example-full-width" cellspacing="0">
    <tr>
      <td>
        <h2>Settings</h2>
      </td>
      <td><button mat-raised-button color="primary" style="margin-left:20px;" (click)="save()">Save</button></td>
      <td></td>
      <!-- <td>
        <button mat-raised-button>Filter</button>
      </td> -->
      <!-- <td>
            <div fxLayout="row wrap" fxLayoutAlign="space-around center">
              <mat-slide-toggle [id]="34343"> fasdfas </mat-slide-toggle>
              <mat-slide-toggle [id]="3433343">fdsfs fasdfas </mat-slide-toggle>
            </div>
          </td> -->
      <td>

      </td>
    </tr>
  </table>
  <!-- </mat-card-content>
</mat-card> -->

  <div class="gap10"></div>

  <!-- Contact Form Section -->
  <form [formGroup]="contactForm">
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutAlign="center stretch">
      <mat-card fxFlex="50%">
        <mat-card-content>
          <h3>My Account</h3>
          <div fxLayout="column">
            <div class="input-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
              <mat-form-field fxFlex> <input matInput type="text" placeholder="first name" formControlName="firstName" /> </mat-form-field>
              <mat-form-field fxFlex> <input matInput type="text" placeholder="last name" formControlName="lastName" />
              </mat-form-field>
            </div>
            <div class="input-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
              <mat-form-field fxFlex> <input matInput type="text" placeholder="Street" formControlName="street" />
              </mat-form-field>
              <mat-form-field fxFlex> <input matInput type="number" placeholder="Street No" formControlName="streetno" /> </mat-form-field>
            </div>
            <div class="input-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
              <mat-form-field fxFlex> <input matInput type="text" placeholder="City" formControlName="city" />
              </mat-form-field>
              <mat-form-field fxFlex> <input matInput type="number" placeholder="Zip" formControlName="zip" />
              </mat-form-field>
            </div>
            <div class="input-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
              <mat-form-field fxFlex="50%"> <input matInput type="text" placeholder="country" formControlName="country" /> </mat-form-field>
            </div>

            <div style="margin-top:22px;font-size:22px;font-weight:bold;">Subscription Plan: <span style="">{{user?.plan}}</span></div>

            <!-- <hr />
             <div class="input-row"  fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
            <mat-form-field fxFlex> <input matInput type="text" placeholder="e-mail" formControlName="email" /> </mat-form-field>
            <mat-form-field fxFlex> <input matInput type="password" placeholder="Password" formControlName="password" /> </mat-form-field>
          </div> -->
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card fxFlex="50%">
        <mat-card-content>
          <h3>Settings</h3>


          <!-- <ngx-auth-firebaseui [signInTabText]="'ngxauthfirebaseui.signInTabText' | translate" [signInCardTitleText]="'ngxauthfirebaseui.signInCardTitleText' | translate" 
            [loginButtonText]="'ngxauthfirebaseui.loginButtonText' | translate" [forgotPasswordButtonText]="'ngxauthfirebaseui.forgotPasswordButtonText' | translate" [nameText]="'ngxauthfirebaseui.nameText' | translate"
            [nameErrorRequiredText]="'ngxauthfirebaseui.nameErrorRequiredText' | translate" [nameErrorMinLengthText]="'ngxauthfirebaseui.nameErrorMinLengthText' | translate"
            [nameErrorMaxLengthText]="'ngxauthfirebaseui.nameErrorMaxLengthText' | translate" [emailText]="'ngxauthfirebaseui.emailText' | translate"
            [emailErrorRequiredText]="'ngxauthfirebaseui.emailErrorRequiredText' | translate" [emailErrorPatternText]="'ngxauthfirebaseui.emailErrorPatternText' | translate"
            [passwordText]="'ngxauthfirebaseui.passwordText' | translate" [passwordErrorRequiredText]="'ngxauthfirebaseui.passwordErrorRequiredText' | translate"
            [registerTabText]="'ngxauthfirebaseui.registerTabText' | translate" [registerCardTitleText]="'ngxauthfirebaseui.registerCardTitleText' | translate"
            [registerButtonText]="'ngxauthfirebaseui.registerButtonText' | translate" [guestButtonText]="'ngxauthfirebaseui.guestButtonText' | translate"
            [resetPasswordTabText]="'ngxauthfirebaseui.resetPasswordTabText' | translate" [resetPasswordInputText]="'ngxauthfirebaseui.resetPasswordInputText' | translate"
            [resetPasswordErrorRequiredText]="'ngxauthfirebaseui.resetPasswordErrorRequiredText' | translate" [resetPasswordErrorPatternText]="'ngxauthfirebaseui.resetPasswordErrorPatternText' | translate"
            [resetPasswordActionButtonText]="'ngxauthfirebaseui.resetPasswordActionButtonText' | translate" [resetPasswordInstructionsText]="'ngxauthfirebaseui.resetPasswordInstructionsText' | translate"
            [emailConfirmationTitle]="'ngxauthfirebaseui.emailConfirmationTitle' | translate" [emailConfirmationText]="'ngxauthfirebaseui.emailConfirmationText' | translate">
          </ngx-auth-firebaseui> -->
        </mat-card-content>
      </mat-card>
    </div>
  </form>

  <div class="gap10"></div>

  <!-- Token Usage History Section (Separate from Contact Form) -->
  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutAlign="center stretch">
    <mat-card fxFlex="100%">
      <mat-card-content>
        <div class="token-usage-container">

          <!-- Account Token Balance -->
          <div class="account-token-balance">
            <h3>💳 Account Token Balance & Costs</h3>
            <p style="margin-bottom: 15px; color: #666; font-size: 14px;">
              Your total token usage and costs across all AI features and requests
            </p>
            <div class="balance-cards">
              <div class="balance-card account-total">
                <div class="card-value">{{ userTokensUsed | number }}</div>
                <div class="card-label">Account Total Tokens Used</div>
              </div>
              <div class="balance-card account-input">
                <div class="card-value">{{ userInputTokensUsed | number }}</div>
                <div class="card-label">Account Input Tokens</div>
              </div>
              <div class="balance-card account-output">
                <div class="card-value">{{ userOutputTokensUsed | number }}</div>
                <div class="card-label">Account Output Tokens</div>
              </div>
              <div class="balance-card account-cost">
                <div class="card-value">{{ formatCost(userTotalCost) }}</div>
                <div class="card-label">Account Total Cost</div>
              </div>
              <div class="balance-card account-input-cost">
                <div class="card-value">{{ formatCost(userInputCost) }}</div>
                <div class="card-label">Account Input Cost</div>
              </div>
              <div class="balance-card account-output-cost">
                <div class="card-value">{{ formatCost(userOutputCost) }}</div>
                <div class="card-label">Account Output Cost</div>
              </div>
              <div class="balance-card account-requests">
                <div class="card-value">{{ userTotalRequests | number }}</div>
                <div class="card-label">Account Total Requests</div>
              </div>
              <div class="balance-card last-usage" *ngIf="userLastTokenUsage">
                <div class="card-value">{{ formatDate(userLastTokenUsage) }}</div>
                <div class="card-label">Last Token Usage</div>
              </div>
              <div class="balance-card last-cost-update" *ngIf="userLastCostUpdate">
                <div class="card-value">{{ formatDate(userLastCostUpdate) }}</div>
                <div class="card-label">Last Cost Update</div>
              </div>
            </div>
          </div>

          <!-- Token Usage Summary (History) -->
          <div class="token-summary">
            <h3>🔢 Recent Usage Summary & Costs</h3>
            <p style="margin-bottom: 15px; color: #666; font-size: 14px;">
              Summary of your last 50 AI requests including costs (detailed history below)
            </p>
            <div class="summary-cards">
              <div class="summary-card total">
                <div class="card-value">{{ totalTokensUsed | number }}</div>
                <div class="card-label">Recent Tokens (50 records)</div>
              </div>
              <div class="summary-card input">
                <div class="card-value">{{ getTotalInputTokensFromHistory() | number }}</div>
                <div class="card-label">Recent Input Tokens</div>
              </div>
              <div class="summary-card output">
                <div class="card-value">{{ getTotalOutputTokensFromHistory() | number }}</div>
                <div class="card-label">Recent Output Tokens</div>
              </div>
              <div class="summary-card cost">
                <div class="card-value">{{ formatCost(getTotalCostFromHistory()) }}</div>
                <div class="card-label">Recent Total Cost</div>
              </div>
              <div class="summary-card input-cost">
                <div class="card-value">{{ formatCost(getTotalInputCostFromHistory()) }}</div>
                <div class="card-label">Recent Input Cost</div>
              </div>
              <div class="summary-card output-cost">
                <div class="card-value">{{ formatCost(getTotalOutputCostFromHistory()) }}</div>
                <div class="card-label">Recent Output Cost</div>
              </div>
              <div class="summary-card requests">
                <div class="card-value">{{ tokenUsageHistory.length }}</div>
                <div class="card-label">Recent Requests</div>
              </div>
            </div>
          </div>

          <!-- Token Usage by Type -->
          <div class="usage-by-type" *ngIf="tokenUsageHistory.length > 0">
            <h4>Usage & Costs by Service Type</h4>
            <div class="type-cards">
              <div class="type-card" *ngFor="let item of getTokenUsageByType() | keyvalue" [style.border-left-color]="getRequestTypeColor(item.key)">
                <div class="type-name">{{ getRequestTypeDisplayName(item.key) }}</div>
                <div class="type-tokens">{{ item.value | number }} tokens</div>
                <div class="type-cost">{{ formatCost(getCostUsageByType()[item.key]) }}</div>
              </div>
            </div>
          </div>

          <!-- Token Usage History -->
          <div class="token-history">
            <div class="history-header">
              <h4>📜 Usage History</h4>
              <div class="header-actions">
                <button mat-icon-button (click)="refreshTokenHistory()" [disabled]="tokenUsageHistoryLoading" title="Refresh">
                  <mat-icon>refresh</mat-icon>
                </button>
                <button mat-button (click)="testTokenCreation()" [disabled]="tokenUsageHistoryLoading" title="Test Token Creation">
                  🧪 Test
                </button>
              </div>
            </div>

            <!-- Loading State -->
            <div *ngIf="tokenUsageHistoryLoading" class="loading-container">
              <mat-spinner diameter="30"></mat-spinner>
              <span>Loading token usage history...</span>
            </div>

            <!-- No Data State -->
            <div *ngIf="!tokenUsageHistoryLoading && tokenUsageHistory.length === 0" class="no-data">
              <mat-icon>info_outline</mat-icon>
              <p>No token usage recorded yet. Start using AI features to see your usage history here.</p>
            </div>

            <!-- History List -->
            <div *ngIf="!tokenUsageHistoryLoading && tokenUsageHistory.length > 0" class="history-list">
              <div class="history-item" *ngFor="let record of tokenUsageHistory">
                <div class="item-header">
                  <span class="service-tag" [style.background-color]="getRequestTypeColor(record.requestType)" [style.color]="'white'">
                    {{ getRequestTypeDisplayName(record.requestType) }}
                  </span>
                  <span class="model-tag" [style.background-color]="getModelDisplayInfo(getModelName(record)).color" [style.color]="'white'">
                    {{ getModelDisplayInfo(getModelName(record)).name }}
                  </span>
                  <span class="timestamp">{{ formatDate(record.timestamp) }}</span>
                </div>
                <div class="item-details">
                  <div class="token-info">
                    <strong>{{ record.tokenUsage?.totalTokens || 0 }} tokens</strong>
                    <span class="breakdown">({{ record.tokenUsage?.promptTokens || 0 }} in + {{ record.tokenUsage?.responseTokens || 0 }} out)</span>
                  </div>
                  <div class="cost-info" *ngIf="record.costInfo">
                    <strong>{{ formatCost(record.costInfo.totalCost) }}</strong>
                    <span class="cost-breakdown">({{ formatCost(record.costInfo.inputCost) }} in + {{ formatCost(record.costInfo.outputCost) }} out)</span>
                  </div>
                  <div class="cost-info" *ngIf="!record.costInfo">
                    <span class="no-cost">No cost data available</span>
                  </div>
                  <div class="request-id">
                    <code>{{ record.requestId }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="gap10"></div>


</div>

<!-- </div> -->